import { FeedbackRowType } from './types';

export const FORM_CLOSE_EVENT = '$$FeedbackFormClose';
export const GLOBAL_STRUCTURE_KEY = '__structure';
export const GLOBAL_METADATA_KEY = '__metadata';
export const GLOBAL_LANGUAGE_KEY = '__language';

export interface IFeedbackFormMetadata {
  uuid: string;
  campaignId: string;
  company: string;
  appDefId?: string;
  editorType?: string;
  esi?: string;
  msid?: string;
}

export enum FormCloseReason {
  Timeout = 'timeout',
  Submitted = 'submitted',
  Closed = 'closed',
}

export type IFrameCloseEvent =
  | {
      reason: FormCloseReason.Closed;
      payload: {
        id: string;
        label: string;
        type: FeedbackRowType;
        value?: string;
      }[];
    }
  | {
      reason: FormCloseReason.Submitted;
      payload: {
        id: string;
        label: string;
        type: FeedbackRowType;
        value?: string;
      }[];
    };
